import React from 'react';
import styles from '../components/TimeLine/TimeLine.module.css'; 
import classNames from 'classnames';

const SkeletonAuditLogTimeline = () => {
  return (
    <div style={{width:'90%'}} data-testid="skeleton-audit-log-timeline">
      {[1, 2, 3].map((group, index) => (
        <div key={index}>


          {[1, 2].map((_, i) => (
            <div key={i} className={styles.timelineRow}>
              <div style={{marginLeft:'2rem'}} className={classNames(styles.skeletonBox)}></div>
              <div className={classNames(styles.skeletonCircle)}></div>
              <div className={styles.details}>
                <div style={{width:'20rem'}}  className={classNames(styles.skeletonBox)}></div>
                <div className={classNames(styles.description, styles.skeletonBox)}></div>
                <div className={classNames(styles.errorMsg, styles.skeletonBox)}></div>
              </div>
            </div>
          ))}
        </div>
      ))}
    </div>
  );
};

export default SkeletonAuditLogTimeline;
